import type { Theme } from "./themes";

/** Neutral fallback when theme tint cannot be computed. */
export const ANIOS_THEME_UNDERLAY_LIGHT = "#c5ced9";
export const ANIOS_THEME_UNDERLAY_DARK = "#0f172a";

function hexToRgb(hex: string): [number, number, number] {
  const normalized = hex.replace("#", "").trim();
  const full =
    normalized.length === 3
      ? normalized
          .split("")
          .map((c) => c + c)
          .join("")
      : normalized;
  return [
    parseInt(full.slice(0, 2), 16),
    parseInt(full.slice(2, 4), 16),
    parseInt(full.slice(4, 6), 16),
  ];
}

/** Linear RGB mix between two hex colours (ratio = weight of `b`). */
export function mixHexColors(a: string, b: string, ratio: number): string {
  const t = Math.max(0, Math.min(1, ratio));
  const [r1, g1, b1] = hexToRgb(a);
  const [r2, g2, b2] = hexToRgb(b);
  const r = Math.round(r1 * (1 - t) + r2 * t);
  const g = Math.round(g1 * (1 - t) + g2 * t);
  const bl = Math.round(b1 * (1 - t) + b2 * t);
  return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${bl.toString(16).padStart(2, "0")}`;
}

/**
 * Muted desktop base tinted with the user's workspace theme accents.
 * Keeps light mode readable while avoiding flat white or muddy brown.
 */
export function resolveDesktopWallpaperUnderlay(theme: Theme): string {
  const base = ANIOS_THEME_UNDERLAY_LIGHT;
  const [c1, c2] = theme.colors;
  if (!c1) return base;
  const withPrimary = mixHexColors(base, c1, 0.22);
  return c2 ? mixHexColors(withPrimary, c2, 0.12) : withPrimary;
}

/** Wallpaper gradient uses the same accent colours as dark mode (theme picker). */
export function resolveThemeWallpaperColors(theme: Theme, _isDark: boolean): string[] {
  return theme.colors;
}
